import { SendMailItem } from '@/features/ap_payees/components/DocInstructionMenu/ActionMenus/SendMailItem';
import { useTranslation } from '@/i18n';
import { ActionMenuItems } from '@moneyforward/ap-frontend-components';
import { useMemo } from 'react';
type ItemArgs = {
  onSendEmail: VoidFunction;
  handleOpenInstructionPdfDialog: VoidFunction;
  disabledSendmail: boolean;
  disabledExportPdf: boolean;
};

export const useItems = ({
  onSendEmail,
  disabledSendmail,
  handleOpenInstructionPdfDialog,
  disabledExportPdf,
}: ItemArgs): ActionMenuItems => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        key: '1',
        label: <SendMailItem disabled={disabledSendmail} />,
        onClick: onSendEmail,
        disabled: disabledSendmail,
      },
      {
        key: '2',
        label: t('instruction_menu_pdf_file'),
        onClick: handleOpenInstructionPdfDialog,
        disabled: disabledExportPdf,
      },
    ],
    [
      handleOpenInstructionPdfDialog,
      onSendEmail,
      disabledSendmail,
      disabledExportPdf,
      t,
    ]
  );
};
